import { Form } from "./Components/Form/Form";
import InfoAlert from "shared/UI/Alerts/InfoAlert";
import { PageHeader } from "UIPalette/PageHeader/PageHeader";
import PageTitle from "UIPalette/PageTitle/PageTitle";
import { useSSO } from "../../../../hooks/useSSO/useSSO";
import { useTranslation } from "react-i18next";
import { NarrowContainer } from "shared/UI/LayoutComponents/LayoutComponents";

export const PasswordManagement = () => {
  const { t } = useTranslation();
  const { signedUpWithSso } = useSSO();
  return (
    <>
      <PageTitle title={t("pageTitle.account.accountSecurity.passwordManagement")} />
      <PageHeader title={t("accountSecurity.passwordManagement.title")} hideForMobile narrowView />
      <NarrowContainer>
        {signedUpWithSso && (
          <InfoAlert title={t("accountSecurity.passwordManagement.ssoSignUpInfo.title")}>
            <p>{t("accountSecurity.passwordManagement.ssoSignUpInfo.message")}</p>
          </InfoAlert>
        )}
        <Form />
      </NarrowContainer>
    </>
  );
};
